<template>
    <ItemGroupSelect
        @update-selected-group="updateSelectedGroup"
        :activeGroup="activeGroup"
        :groups="groups"
        :className="'statistics'"></ItemGroupSelect>

    <div class="country__select-wrapper">
        <Select
            :modelValue="selectedYear"
            :options="availableYears"
            style="width: 100%"
            @update:modelValue="year => updateSelectedYear(year)"
        />
    </div>

    <div class="country content-width--large">
        <ItemCountyTotals
            :topFiveItems="topFiveItems"
            :activeGroup="activeGroup"
            :loading="loadingCounty"
            @highlight-county="highlightCounty"
            @clear-highlight="clearHighlight"
        ></ItemCountyTotals>
        <ToplistUsers
            :selectedMunicipality="selectedMunicipality"
            :selectedItem="selectedItem"
            :filteredData="filteredData"
            :topList="topList"
            :topListTotal="topListTotal"
            :topListPage="topListPage"
            :topListPerPage="topListPerPage"
            :loadingToplist="loadingToplist"
            :data="data"
            :items="items"
            :activeGroup="activeGroup"
            :groupName="groupName"
            :season="season"
            :selectedYear="selectedYear"
            @update-selected-municipality="updateSelectedMunicipality"
            @update-selected-item="updateSelectedItem"
            @update-toplist-page="updateTopListPage"
        ></ToplistUsers>
    </div>
</template>
<script>
    import * as d3 from "d3";

    import Select from 'primevue/select';
    import ToplistUsers from './components/ToplistUsers';
    import ItemCountyTotals from './components/ItemCountyTotals';
    import ItemGroupSelect from './components/ItemGroupSelect';

    export default {
        components: {
            Select,
            ItemGroupSelect,
            ItemCountyTotals,
            ToplistUsers
        },
        props : [
            'season'
        ],
        data() {
            return {
                municipalitiesMapUrl: '/img/country/norway-municipalities.new.geojson',
                groupsUrl   : '/fetch/itemgroups',
                itemsUrl    : '/fetch/items',
                dataUrl     : '/fetch/registrations/locations',
                country     : null,
                data        : [],
                topList     : [],
                topListTotal: 0,
                topListPage : 0,
                topListPerPage: 15,
                activeGroup : 1,
                groups      : [],
                items       : [],
                selectedYear: null,
                loadingCounty: true,
                loadingToplist: true,
                calculatedTotals: false,
                counties    : [
                    {id: 3,  name: 'Oslo',                 amounts: []},
                    {id: 11, name: 'Rogaland',             amounts: []},
                    {id: 15, name: 'Møre og Romsdal',      amounts: []},
                    {id: 18, name: 'Nordland',             amounts: []},
                    {id: 31, name: 'Østfold',              amounts: []},
                    {id: 32, name: 'Akershus',             amounts: []},
                    {id: 33, name: 'Buskerud',             amounts: []},
                    {id: 34, name: 'Innlandet',            amounts: []},
                    {id: 39, name: 'Vestfold',             amounts: []},
                    {id: 40, name: 'Telemark',             amounts: []},
                    {id: 42, name: 'Agder',                amounts: []},
                    {id: 46, name: 'Vestland',             amounts: []},
                    {id: 50, name: 'Trøndelag',            amounts: []},
                    {id: 55, name: 'Troms',                amounts: []},
                    {id: 56, name: 'Finnmark',             amounts: []}
                ],
                selectedMunicipality: 0,
                selectedItem        : 0,
                itemFilter          : null,
                locationFilter      : null,
                userData            : null,
                userRegistrations   : null,
                highlightedElementIds: [],
                selectedMapElementIds: []
            }
        },
        created() {
            this.selectedYear = Number(this.season);
            this.fetchData();
            this.fetchGroups();
            this.fetchItems();
            this.fetchToplist();
            this.fetchUserData();
            this.fetchUserRegistratons();
            d3.json(this.municipalitiesMapUrl).then((geojson) => {
                this.renderMap(geojson);
            });
        },
        methods: {
            fetchData() {
                this.loadingCounty = true;
                const url = this.dataUrl + (this.selectedYear ? `?year=${this.selectedYear}` : '');
                this._get(url).then(data => {
                    this.data = data;

                    // sort alphabetically
                    const collator = new Intl.Collator('nb');
                    this.data.sort((a, b) => {
                        return collator.compare(a.name, b.name);
                    });

                    this.loadingCounty = false;
                });
            },
            fetchGroups() {
                this._get(this.groupsUrl).then(data => {
                    this.groups = data;
                });
            },
            fetchItems() {
                this._get(this.itemsUrl).then(data => {
                    this.items = data;
                    this.autoSelectSingleItem();
                    this.fetchToplist();
                });
            },
            fetchToplist(){
                let fetchUrl = '/fetch/registrations/toplist?';
                let fetchParams = '';

                // Build query string for toplist fetch API
                if(this.locationFilter){
                    fetchParams = fetchParams + this.locationFilter + '&';
                }
                if(this.itemFilter){
                    fetchParams = fetchParams + this.itemFilter + '&';
                }
                fetchParams = fetchParams + 'group=' + this.activeGroup;
                if (this.selectedYear) {
                    fetchParams = fetchParams + '&year=' + this.selectedYear;
                }
                fetchParams = fetchParams + '&page=' + (this.topListPage + 1) + '&per_page=' + this.topListPerPage;

                this.loadingToplist = true;
                this.topList = [];

                // Fetch data from API, reading the total record count off the
                // X-Total-Count header so the paginator knows how many pages exist.
                fetch(fetchUrl + fetchParams).then(response => {
                    this.topListTotal = Number(response.headers.get('X-Total-Count')) || 0;
                    return response.json();
                }).then(data => {
                    this.topList = data;
                    this.loadingToplist = false;
                    // console.log('toplist:', data);
                }).catch(error => {
                    console.error(error);
                    this.loadingToplist = false;
                });
            },
            updateTopListPage(page){
                this.topListPage = page;
                this.fetchToplist();
            },
            fetchUserData(){
                let fetchUrl = '/fetch/user';

                // Fetch data from API
                this._get(fetchUrl).then(data => {
                    this.userData = data;
                    // console.log('User data: ', data);
                });
            },
            fetchUserRegistratons(){
                let fetchUrl = '/fetch/user/registrations?';
                let fetchParams = '';

                fetchParams = fetchParams + 'group=' + this.activeGroup;

                console.log(fetchUrl + fetchParams);

                // Fetch data from API
                this._get(fetchUrl + fetchParams).then(data => {
                    // console.log('User registrations: ', data);
                    let registeredAmount = 0;
                    data[0].registrations.forEach(registration => {
                        registeredAmount += registration.amount;
                    });
                    this.userRegistrations = registeredAmount;
                    // console.log('User registrations sum: ', this.userRegistrations);
                });
            },
            async _get(url) {
                try {
                    const response = await fetch(url);

                    return await response.json();
                } catch(error) {
                    return console.error(error);
                }
            },
            updateSelectedItem(itemId){
                this.selectedItem = itemId;
                if (itemId != 0){
                    this.itemFilter = 'item=' + itemId;
                } else {
                    this.itemFilter = null;
                }
                this.topListPage = 0;
                this.fetchToplist();
            },
            updateSelectedMunicipality(municipalityId){
                this.selectedMunicipality = municipalityId;
                if (municipalityId != 0){
                    this.locationFilter = 'location=' + municipalityId;
                } else {
                    this.locationFilter = null;
                }
                this.topListPage = 0;
                this.fetchToplist();
            },
            updateSelectedYear(year) {
                this.selectedYear = Number(year);
                this.data = [];
                this.calculatedTotals = false;
                this.counties = this.counties.map(c => ({ ...c, amounts: [] }));
                this.topListPage = 0;
                this.fetchData();
                this.fetchToplist();
            },
            updateSelectedGroup(groupId){
                if (this.groups.length && this.groups.find(group => Number(group.id) === Number(groupId))) {
                    this.activeGroup = Number(groupId);
                }

                this.selectedItem = 0;
                this.topListPage = 0;
                this.itemFilter = null;
                this.autoSelectSingleItem();
                this.fetchToplist();
            },
            getActiveItems() {
                return this.items.filter(item => {
                    return Number(item.group_id) === Number(this.activeGroup);
                });
            },
            // If the active item group only has one type of berry/item, select
            // it automatically instead of leaving the filter on "Alle typer".
            autoSelectSingleItem() {
                const activeItems = this.getActiveItems();

                if (activeItems.length === 1) {
                    this.selectedItem = activeItems[0].id;
                    this.itemFilter = 'item=' + activeItems[0].id;
                }
            },
            getActiveGroup() {
                return this.groups.filter(group => {
                    return Number(group.id) === Number(this.activeGroup);
                });
            },
            getCountyId(municipality) {
                const municipalityId = municipality.id.toString();

                return municipalityId.slice(0, municipalityId.length - 2);
            },
            // Renders the municipality-level map from GeoJSON (Kartverket data,
            // CC BY 4.0, via https://github.com/robhop/fylker-og-kommuner). Each
            // <path> is id'd by kommunenummer so highlighting/selection can look
            // elements up directly, the same way the old per-county SVG did.
            renderMap(geojson) {
                const projection = d3.geoMercator().fitSize([1000, 1000], geojson);
                const path = d3.geoPath().projection(projection);
                const [[x0, y0], [x1, y1]] = path.bounds(geojson);
                const [tx, ty] = projection.translate();
                projection.translate([tx - x0, ty - y0]);

                const svg = d3.select('[data-country]')
                    .append('svg')
                    .attr('viewBox', `0 0 ${x1 - x0} ${y1 - y0}`)
                    .attr('preserveAspectRatio', 'xMidYMid meet')
                    .attr('class', 'country__map');

                const municipality = svg.selectAll('path')
                    .data(geojson.features)
                    .enter()
                    .append('path')
                    // kommunenummer is a zero-padded string (e.g. "0301"); normalize
                    // to match the non-padded ids used by municipalities.json/registrations.
                    .attr('id', d => Number(d.properties.kommunenummer))
                    .attr('class', 'country__municipality')
                    .attr('d', path);

                municipality.append('title')
                    .text(d => d.properties.kommunenavn);

                this.country = svg.node();
                this.updateSelectedCountyOnMap();
            },
            getElementsForCounty(countyId) {
                if (!this.country) return [];

                return Array.from(this.country.querySelectorAll('path')).filter(element => {
                    return Number(this.getCountyId({ id: element.id })) === Number(countyId);
                });
            },
            highlightCounty(countyId) {
                if (!countyId || !this.country) return;

                // Clear previous highlight
                this.clearHighlight();

                // Add highlight to every municipality within the county
                const elements = this.getElementsForCounty(countyId);
                elements.forEach(element => element.classList.add('highlight'));
                this.highlightedElementIds = elements.map(element => element.id);
            },
            clearHighlight() {
                if (this.highlightedElementIds.length && this.country) {
                    this.highlightedElementIds.forEach(id => {
                        const element = this.country.getElementById(id);
                        if (element) {
                            element.classList.remove('highlight');
                        }
                    });
                }
                this.highlightedElementIds = [];
            },
            // Persistently highlights the currently selected municipality, or
            // every municipality within the currently selected fylke, independent
            // of the transient hover highlight used by ItemCountyTotals.
            updateSelectedCountyOnMap() {
                if (!this.country) return;

                this.selectedMapElementIds.forEach(id => {
                    const element = this.country.getElementById(id);
                    if (element) {
                        element.classList.remove('county-selected');
                    }
                });
                this.selectedMapElementIds = [];

                if (this.selectedMunicipality == 0) return;

                const isCounty = this.counties.some(c => c.id === Number(this.selectedMunicipality));
                const elements = isCounty
                    ? this.getElementsForCounty(this.selectedMunicipality)
                    : [this.country.getElementById(this.selectedMunicipality.toString())].filter(Boolean);

                elements.forEach(element => element.classList.add('county-selected'));
                this.selectedMapElementIds = elements.map(element => element.id);
            }
        },
        computed: {
            availableYears() {
                const years = [];
                for (let y = Number(this.season); y >= 2016; y--) {
                    years.push(y);
                }
                return years;
            },
            groupName: function() {
                const activeGroup = this.getActiveGroup();

                return activeGroup.length ? activeGroup[0].name : '';
            },
            filteredData: function() {
                let filteredData = JSON.parse(JSON.stringify(this.data));

                filteredData = filteredData.filter(municipality => {
                    return municipality.itemGroups.filter(i => Number(i.id) === Number(this.activeGroup)).length;
                });

                if (this.selectedMunicipality != 0) {
                    filteredData = filteredData.filter(i => Number(i.id) === Number(this.selectedMunicipality));
                }

                if (this.selectedItem != 0) {
                    filteredData = filteredData.map(i => {
                        const items = i.itemGroups.filter(i => Number(i.id) === Number(this.activeGroup));
                        if (!items.length > 0) return i;

                        const selectedItem = items[0].items.filter(item => {
                            return Number(item.id) === Number(this.selectedItem);
                        });

                        for (let j = 0; j < i.itemGroups.length; j++) {
                            if (Number(i.itemGroups[j].id) === Number(this.activeGroup)) {
                                i.itemGroups[j].totals = selectedItem.length ? selectedItem[0].amount : 0;
                            }
                        }

                        return i;
                    });
                }

                filteredData.sort((a, b) => {
                    const aItems = a.itemGroups.filter(i => Number(i.id) === Number(this.activeGroup));
                    const bItems = b.itemGroups.filter(i => Number(i.id) === Number(this.activeGroup));

                    if (aItems.length > 0 && bItems.length > 0) {
                        return bItems[0].totals > aItems[0].totals ? 1 : -1;
                    } else if (aItems.length > 0) {
                        return -1;
                    } else if (bItems.length > 0) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                return filteredData.slice(0, 27);
            },
            topFiveItems: function() {
                if (!this.calculatedTotals && this.data.length > 0) {
                    let total = 0;
                    for (const municipality of this.data) {
                        const countyId = this.getCountyId(municipality);
                        const county   = this.counties.filter(c => {
                            return c.id === Number(countyId);
                        })[0];

                        if (county.amounts.length === 0) {
                            for (const item of this.items) {
                                county.amounts.push({...item, amount: 0});
                            }
                        }

                        for (const itemGroup of municipality.itemGroups) {
                            for (const item of itemGroup.items) {
                                for (const countyItem of county.amounts) {
                                    if (Number(countyItem.id) == Number(item.id)) {
                                        countyItem.amount += item.amount;
                                        total += item.amount;
                                    }
                                }
                            }
                        }
                    }

                    this.calculatedTotals = total > 0;
                }

                const activeGroup = this.getActiveGroup()[0];

                const topFive = [];
                for (const item of this.items) {
                    if (item.group_id != this.activeGroup) continue;

                    topFive.push({
                        ...item,
                        amount: 0,
                        county: null,
                    });
                }

                for (const county of this.counties) {
                    for (const item of county.amounts) {
                        for (const topItem of topFive) {
                            if (Number(topItem.id) == Number(item.id) && item.amount > topItem.amount) {
                                topItem.amount = item.amount;
                                topItem.county = county;
                            }
                        }
                    }
                }

                return topFive;
            }
        },
        watch: {
            // activeGroup: function() {
            //     this.fillMap();
            // }
            selectedMunicipality() {
                this.updateSelectedCountyOnMap();
            }
        }
    }
</script>
